import { AsyncThunk, createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "app/rootReducer";
import { AppDispatch } from "app/store";
import { AIData, FirebaseRefs, GetStartedStoreTypes } from "interfaces";
import { FirestoreService } from "services";

import { initialState } from "./helper";

export const setInitialDetails = createAction<{
  data: GetStartedStoreTypes;
  step: number;
  isCompleted?: boolean;
}>("setInitialDetails");

export const getInitialDetails: AsyncThunk<
  {
    data: GetStartedStoreTypes;
    step: number;
    isCompleted?: boolean;
  },
  { uid: string; cb: () => void },
  {
    state: RootState;
    rejectValue: string;
  }
> = createAsyncThunk<
  {
    data: GetStartedStoreTypes;
    step: number;
    isCompleted?: boolean;
  },
  { uid: string; cb: () => void },
  {
    state: RootState;
    dispatch: AppDispatch;
    rejectValue: string;
  }
>("getInitialDetails", async (payload, { rejectWithValue }) => {
  try {
    const doc = await FirestoreService.getDocument({ coll: FirebaseRefs.INITIAL_DETAILS, docId: payload.uid });
    if (doc.exists) {
      payload.cb();

      return {
        data: doc?.data?.data as GetStartedStoreTypes,
        step: doc?.data?.step ?? 1,
        isCompleted: doc?.data?.isCompleted ?? false
      };
    } else {
      return {
        data: initialState,
        step: 1,
        isCompleted: false
      };
    }
  } catch (err) {
    return rejectWithValue(err as string);
  }
});

export const setAIData = createAction<AIData>("setAIData");
